export default __webpack_public_path__ + "static/media/lucky7new.115d62aa.jpg";